import classNames from "classnames";
import type { KeyboardEvent, RefObject } from "react";

import { legacyClassNames } from "@/react/helpers/cssAnchorHelpers";

export interface SearchInputProps {
  autoFocus?: boolean;
  dataTestId?: string;
  disabled?: boolean;
  handleOpen: () => void;
  onKeyDown?: (event: KeyboardEvent<HTMLInputElement>) => void;
  onSearchChange: (searchValue: string) => void;
  placeholder?: string;
  searchInputRef: RefObject<HTMLInputElement>;
  searchValue: string;
}

export const SearchInput = ({
  searchInputRef,
  onSearchChange,
  placeholder,
  dataTestId,
  searchValue,
  handleOpen,
  onKeyDown,
  disabled = false,
  autoFocus = false,
}: SearchInputProps) => (
  <input
    onFocus={handleOpen}
    ref={searchInputRef}
    value={searchValue}
    placeholder={placeholder}
    disabled={disabled}
    data-testid={dataTestId ? `${dataTestId}-search-input` : undefined}
    className={classNames(
      legacyClassNames("search-input"),
      "leading-6 placeholder:text-light placeholder:opacity-100 disabled:cursor-not-allowed disabled:opacity-50",
      {
        "!bg-secondary cursor-not-allowed": disabled,
      },
    )}
    onChange={event => {
      event.stopPropagation();
      handleOpen();
      onSearchChange(event.target.value);
    }}
    autoCapitalize="false"
    autoComplete="false"
    onKeyDown={onKeyDown}
    autoFocus={autoFocus}
  />
);
